import React from "react";
import "./styles/index.scss";
import Popup from "../index";

const SessionExpiredPopup = (props) => {
  const { isOpen, onClose } = props;

  return (
    <React.Fragment>
      <Popup isOpen={isOpen} onClosePopup={onClose}>
        <div className="session-expired-container">
          <div className="session-expired-form-container">
            <i className="close-icon" aria-hidden="true" onClick={onClose} />
            <div className="session-expired-body-container">
              <div className="session-expired-logo" />
              <div className="session-expired-body">
                <div className="session-expired-title">Session Expired</div>
              </div>
            </div>
            <div className="separator" />
            <div className="session-expired-button" onClick={onClose}>
              log in again
            </div>
          </div>
        </div>
      </Popup>
    </React.Fragment>
  );
};

export default SessionExpiredPopup;
